import { apiClient } from './api-client';

export interface Priority {
  id: string;
  tenantId: string;
  code: string;
  name: string;
  colorHex: string;
  sortOrder: number;
  isDefault: boolean;
  isEmergency: boolean;
  responseTimeHours: number | null;
  completionTargetHours: number | null;
  escalationThresholdPercent: number | null;
  escalationNotifyRoles: string[];
  isActive: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PriorityListResponse {
  items: Priority[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreatePriorityPayload {
  code: string;
  name: string;
  colorHex?: string;
  sortOrder?: number;
  isDefault?: boolean;
  isEmergency?: boolean;
  responseTimeHours?: number;
  completionTargetHours?: number;
  escalationThresholdPercent?: number;
  escalationNotifyRoles?: string[];
}

export type UpdatePriorityPayload = Partial<CreatePriorityPayload> & { isActive?: boolean };

export const priorityService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<PriorityListResponse> =>
    apiClient.get<PriorityListResponse>('/priorities', { params }).then((r) => r.data),

  listAll: (): Promise<Priority[]> =>
    apiClient
      .get<PriorityListResponse>('/priorities', { params: { pageSize: 100 } })
      .then((r) => r.data.items),

  create: (payload: CreatePriorityPayload): Promise<Priority> =>
    apiClient.post<Priority>('/priorities', payload).then((r) => r.data),

  update: (id: string, payload: UpdatePriorityPayload): Promise<Priority> =>
    apiClient.patch<Priority>(`/priorities/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/priorities/${id}`).then(() => undefined),
};
